<template>
	<IconButtonLayout class="sidebar-button">
		<template #default="{ iconClass }">
			<FontAwesomeIcon
				v-if="disposition === `CLOSE`"
				:title="title"
				:class="iconClass"
				:icon="[ `fas`, `sidebar`]"
			/>
			<FontAwesomeIcon
				v-if="disposition === `OPEN`"
				:title="title"
				:class="iconClass"
				:icon="[ `fas`, `sidebar-flip`]"
			/>
		</template>
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "SidebarButton",
	components: {
		IconButtonLayout,
	},
	props: {
		title: {
			type: String,
			default: "",
		},
		disposition: {
			type: String,
			required: true,
			validator: value => [ "OPEN", "CLOSE", ].includes( value ),
		},
	},
};
</script>

<style lang="scss" scoped></style>
